import DateItem from './date-item'
import { $t } from '@/plugin/i18n'

// 自定义输入选项的3中输入方式[1:文本,2:数字,3:日期]
const fieldTypeMap = [
  '',
  {
    component: {
      props: ['value', 'item'],
      // created() {
      //   if (this.item && this.item.defaultValue && this.value === '') {
      //     this.$emit('input', this.item.defaultValue)
      //   }
      // },
      render() {
        return <el-input value={this.value} on-input={(...rest) => this.$emit('input', ...rest)} />
      }
    }
  },
  {
    component: {
      props: ['value', 'item'],
      computed: {
        fildValue() {
          return this.value === 0 ? this.value : this.value || undefined
        }
      },
      render() {
        return <el-input-number controlsPosition='right' style='width: 100%;' value={this.fildValue} on-input={this.changeValue} />
      },
      methods: {
        changeValue(value) {
          this.$emit('input', value === 0 ? value : value || '')
        }
      }
    }
  },
  {
    component: DateItem
  }
]
// 自定义输入选项的验证触发方式
const fieldTriggerMap = [
  '',
  'blur',
  'blur',
  'change'
]

const defaultValidator = (rule, value, callback) => {
  callback()
}

const validatorMap = [
  defaultValidator,
  (rule, value, callback) => {
    if (value && value.length > 100) {
      callback(new Error($t('common.tooLongTip')))
    } else {
      callback()
    }
  },
  (rule, value, callback) => {
    const string = value ? value.toString() : ''
    const stringArr = string.split('.')
    if (stringArr[1] && stringArr[1].length > 6) {
      callback(new Error($t('common.fixedInSix')))
    } else if (string && string.replace('.', '').length > 20) {
      callback(new Error($t('common.tooLongNumber')))
    } else {
      callback()
    }
  },
  defaultValidator
]

export function getData(formItemMap) {
  const data = {}
  Object.keys(formItemMap).forEach(key => {
    data[key] = formItemMap[key].default
  })
  return data
}

export function getMapFormItem(map) {
  return map
}

// 格式化验证规则（转换规则消息中的国际化）
function getRules(rules) {
  if (Array.isArray(rules)) {
    return rules.map(rule => getRules.call(this, rule))
  }
  return {
    ...rules,
    message: rules.message,
    validator: rules.validator ? rules.validator.bind(this) : rules.validator
  }
}

export function getFormatItem(item) {
  return {
    ...item,
    col: item.col ? item.col : { span: 8 },
    rules: item.rules ? getRules.call(this, item.rules) : []
  }
}

export function initGoup(group = []) {
  const groupMap = []
  let itemMap = {}
  group.forEach(groupItem => {
    const item = getMapFormItem(groupItem)
    if (Array.isArray(item)) {
      const groupData = initGoup.call(this, item)
      groupMap.push(groupData.groupMap)
      itemMap = { ...itemMap, ...groupData.itemMap }
    } else if (item.prop) {
      groupMap.push(item.prop)
      itemMap[item.prop] = getFormatItem.call(this, item)
    }
  })
  return { groupMap, itemMap }
}

export function initForm(form) {
  let formItemMap = {}
  const defaultFormMap = []
  form.forEach(item => {
    const formMap = {
      ...item
    }
    const { groupMap, itemMap } = initGoup.call(this, item.group)
    formMap.group = groupMap
    formItemMap = { ...formItemMap, ...itemMap }
    defaultFormMap.push(formMap)
  })
  return { formItemMap, defaultFormMap }
}

export function getCustomValidator(item) {
  const validator = validatorMap[item.fieldType] || defaultValidator
  return [
    { required: !!item.isRequired, message: 'common.required', trigger: fieldTriggerMap[item.fieldType] || 'blur' },
    { validator, trigger: fieldTriggerMap[item.fieldType] || 'blur' }
  ]
}

export function getCustomForm(form) {
  const searchForm = form
    .filter(item => !!item.isDisplay && item.displayPage && item.displayPage.includes('3'))
    .sort((a, b) => a.displayOrder >= b.displayOrder ? 1 : -1)
    .map(item => {
      return {
        prop: item.fieldNo,
        label: item.fieldNoName || item.fieldName,
        formItem: fieldTypeMap[item.fieldType] ? { ...fieldTypeMap[item.fieldType], dateFormat: item.dateFormat } : 'el-input',
        default: item.defaultValue || undefined,
        rules: getCustomValidator(item)
      }
    })
  return [
    {
      title: 'formTitle.customInfo',
      // group: formatFormInRows(searchForm),
      group: searchForm
    }
  ]
}

// 获取自定义选项数据[表单身中的]
export function getCustomTableFormItem(form) {
  return form
    .filter(item => !!item.isDisplay && item.displayPage && item.displayPage.includes('4'))
    .sort((a, b) => a.displayOrder >= b.displayOrder ? 1 : -1)
    .map(item => {
      return {
        prop: item.fieldNo,
        label: item.fieldNoName || item.fieldName,
        editor: fieldTypeMap[item.fieldType] ? { ...fieldTypeMap[item.fieldType], item: item, dateFormat: item.dateFormat } : 'el-input',
        minWidth: 150,
        default: item.defaultValue || undefined,
        rules: [{ required: !!item.isRequired, message: 'common.required' + (item.fieldNoName || item.fieldName), trigger: fieldTriggerMap[item.fieldType] || 'blur' }]
      }
    })
}
